export function calculateAge(birthdateStr) {
    const birthDate = new Date(birthdateStr)
    const today = new Date()

    let age = today.getFullYear() - birthDate.getFullYear()

    const isBeforeBirthday =
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())

    if (isBeforeBirthday) {
        age--
    }

    return age
}

export function calculateKoreanAge(birthdateStr) {
    const birthYear = new Date(birthdateStr).getFullYear()
    const currentYear = new Date().getFullYear()

    return currentYear - birthYear + 1
}
